import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface ButtonProps {
  component: Component
  locale: LocaleCode
  style: React.CSSProperties
}

export function Button({ component, locale, style }: ButtonProps) {
  const config = component.config as any
  const text = getLocalizedText(config.text, locale)
  const href = config.href
  const variant = config.variant || 'primary'

  const variantMap = {
    primary: 'bg-primary text-primary-foreground hover:opacity-90',
    secondary: 'bg-secondary text-secondary-foreground hover:opacity-90',
    outline: 'bg-transparent border border-current hover:opacity-90',
  }
  const variantClasses = variantMap[variant as keyof typeof variantMap] || 'bg-primary text-primary-foreground hover:opacity-90'

  const buttonStyle: React.CSSProperties = {
    ...style,
    padding: style.padding || undefined,
    borderRadius: style.borderRadius || undefined,
  }

  const className = cn(
    'inline-block cursor-pointer no-underline transition-colors',
    !style.padding && 'px-5 py-2.5',
    !style.borderRadius && 'rounded',
    variantClasses
  )

  if (href) {
    return (
      <a href={href} style={buttonStyle} className={className}>
        {text}
      </a>
    )
  }

  return (
    <button style={buttonStyle} className={className}>
      {text}
    </button>
  )
}
